var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendEmail = function SvgSendEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55007 10.387C2.24419 10.3007 1.97401 10.1187 1.77913 9.86763C1.58426 9.61657 1.47495 9.30968 1.46724 8.99196C1.45952 8.67424 1.5538 8.36241 1.73626 8.10218C1.91871 7.84196 2.17974 7.64704 2.48107 7.546L22.5521 1C22.6835 0.957141 22.8243 0.951416 22.9588 0.983456C23.0933 1.0155 23.2164 1.08406 23.3145 1.18158C23.4125 1.27911 23.4817 1.40181 23.5145 1.53616C23.5472 1.67051 23.5422 1.8113 23.5001 1.943L16.9591 22.024C16.8585 22.3258 16.6637 22.5874 16.4033 22.7703C16.1429 22.9531 15.8307 23.0476 15.5127 23.0398C15.1946 23.0319 14.8875 22.9222 14.6364 22.7268C14.3854 22.5313 14.2037 22.2604 14.1181 21.954L11.8721 12.623L2.55007 10.387Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3151 1.18L11.8721 12.623",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSendEmail;